var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightRedIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 1340,
    viewBox: "0 0 62 1340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 689.03C24.043 689.03 28.8797 687.027 32.4457 683.461C36.0117 679.895 38.015 675.058 38.015 670.015C38.015 664.972 36.0117 660.135 32.4457 656.569C28.8797 653.003 24.043 651 18.9999 651L18.9999 689.03Z",
    fill: "#DB3523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 670.44H23.6083V674.255L30.951 670.014L23.6083 665.774V669.586H18.9999V670.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0L19 1340",
    stroke: "black",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 1340,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightRedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/right_red_icon.89f8e300a3adfc55d4b1e199f7843158.svg";